import { computed, inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import * as GuestsActions from './guests.actions';
import { CreateGuestData, GuestsQueryParams, UpdateGuestData } from './guests.actions';
import * as GuestsSelectors from './guests.selectors';

@Injectable({
  providedIn: 'root',
})
export class GuestsFacade {
  private store = inject(Store);

  guests$ = this.store.select(GuestsSelectors.selectAllGuests);
  loading$ = this.store.select(GuestsSelectors.selectGuestsLoading);
  error$ = this.store.select(GuestsSelectors.selectGuestsError);
  pagination$ = this.store.select(GuestsSelectors.selectGuestsPagination);

  guests = toSignal(this.guests$, { initialValue: [] });
  loading = toSignal(this.loading$, { initialValue: false });

  filteredGuests = computed(() => {
    return this.guests();
  });

  loadGuests(params?: GuestsQueryParams): void {
    this.store.dispatch(GuestsActions.loadGuests({ params }));
  }

  createGuest(guestData: CreateGuestData): void {
    this.store.dispatch(GuestsActions.createGuest({ guestData }));
  }

  updateGuest(id: string, guestData: UpdateGuestData): void {
    this.store.dispatch(GuestsActions.updateGuest({ id, guestData }));
  }

  deleteGuest(id: string): void {
    this.store.dispatch(GuestsActions.deleteGuest({ id }));
  }

  uploadGuestPhoto(id: string, file: File): void {
    this.store.dispatch(GuestsActions.uploadGuestPhoto({ id, file }));
  }

  deleteGuestPhoto(id: string): void {
    this.store.dispatch(GuestsActions.deleteGuestPhoto({ id }));
  }
}
